import {Fancybox} from "@fancyapps/ui";
export default function  openAdjunto(base64:string) {
    if(base64.includes("pdf") && !!(window as any).ReactNativeWebView){
        let ms = {
            action: "showPdf",
            payload:  {
                base64: base64,
            }
        };

      return (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))
    }


    new Fancybox(
        [
            {
                src: base64,
            },
        ],
        {
            defaultType: base64.includes("pdf") ? "iframe" : "image",
            // Fullscreen:{
            //     autoStart: true
            // }
        }
    );

}
